import { createRouter, createWebHashHistory } from 'vue-router';
const router = createRouter({
    history: createWebHashHistory(),
    base: '/',
    routes: [
      {
        path: '',
        component: () => import('@/components/AboutComponent.vue'),
      },

      {
        path: '/about',
        component: () => import('@/components/AboutComponent.vue'),
      },
     
      {
        path: '/solution',
        component: () => import('@/components/SolutionComponent.vue'),
      },     
      
      {
        path: '/contact',
        component: () => import('@/components/ContactComponent.vue'),
      },     
      
      {
        path: '/work',
        component: () => import('@/components/WorkComponent.vue'),
      },     
      
      {
        path: '/project',
        component: () => import('@/components/ProjectComponent.vue'),
      },     
      
      {
        path: '/feedback',
        component: () => import('@/components/FeedbackComponent.vue'),
      },     
            
      {
        path: '/partner',
        component: () => import('@/components/PartnerComponent.vue'),
      },     
        
      {
        path: '/publish',
        component: () => import('@/components/PublishComponent.vue'),
      },

      {
        path: '/news',
        component: () => import('@/components/NewsComponent.vue'),
      },
      
      {
        path: '/contact',
        component: () => import('@/components/ContactComponent.vue'),
      }
    ],
  });

  export default router;
  